import { render, staticRenderFns } from "./ConfirmOrderData.vue?vue&type=template&id=00ed7990&scoped=true&"
import script from "./ConfirmOrderData.vue?vue&type=script&lang=js&"
export * from "./ConfirmOrderData.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmOrderData.vue?vue&type=style&index=0&id=00ed7990&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ed7990",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VRow})
